import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {

  get show() {return this.alertService.isShowing}
  get message() {return this.alertService.message}
  get header() {return this.alertService.header}
  get translate() {return this.alertService.translateY}

  constructor(private alertService: AlertService) { }

  ngOnInit(): void {
  }

  close() {
    this.alertService.close();
  }

}
